<template>
  <v-dialog v-model="dialog" persistent width="800px" @keydown.esc="hide">
    <v-form>
      <v-card>
        <v-card-title class="card-panel blue lighten-3">Клиент агентства</v-card-title>

        <v-container>
          <span class="font-italic">Этот атрибут используется в случае работы через агентство. Контрагентом в активности должно быть указано агентство, а клиентом - заказчик агентства.</span>

          <v-autocomplete v-model="form.client_company_id"
            autofocus
            clearable
            :items="companies"
            hint="Компания (клиент агентства)"/>
        </v-container>

        <v-card-actions>
          <v-btn raised @click="hide">Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit" raised color="primary" :loading="loading" @click.prevent="submitAction">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script type="text/javascript">
import api from '@/api'

export default {
  props: [ 'activity' ],
  data: () => ({
    dialog: false,
    loading: false,
    companies: [],
    form: { client_company_id: 0 }
  }),
  methods: {
    open () {
      api.get('companies/shortList').then(response => {
        if ( response.data.$result !== 'ok' ) this.$root.$alert(response.data.data, true)
        this.companies = response.data.data.rows.filter(cur => cur[0] != this.activity.companyID).map(cur => ({ value: cur[0], text: cur[1].substr(0,80)}))
        this.form = { client_company_id: this.activity.client_company_id }
        this.dialog = true
      })
    },
    hide () {
      this.dialog = false
    },
    submitAction() {
      this.loading = true
      let data = { client_company_id: this.form.client_company_id ? this.form.client_company_id : 0 }
      api.post('activities/setClient/'+this.activity.activityID, data).then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.hide()
        this.$emit('updated');
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>
